import React from "react";
import { useSelector } from "react-redux";
import {
  selectPanelMode,
  selectSelectedQuestionId,
  selectSelectedCategoryIdx,
} from "./editorSlice";
import ClueEditForm from "./ClueEditForm";
import CategoryEditForm from "./CategoryEditForm";
import "./roundEditor.css";

const EmptyState = () => (
  <div className="re-panel-placeholder">
    <div className="re-panel-placeholder-icon">✎</div>
    <div className="re-panel-placeholder-text">
      Select a clue or category to start editing
    </div>
  </div>
);

const EditorPanel = ({ round, isFinal = false }) => {
  const panelMode = useSelector(selectPanelMode);
  const selectedQuestionId = useSelector(selectSelectedQuestionId);
  const selectedCategoryIdx = useSelector(selectSelectedCategoryIdx);

  // Re-key on selection so the panel's entrance animation re-runs each time the
  // spotlight moves to a different clue/category.
  let content;
  if (panelMode === "clue" && selectedQuestionId) {
    content = (
      <ClueEditForm
        key={`clue-${selectedQuestionId}`}
        questionId={selectedQuestionId}
        round={round}
        isFinal={isFinal}
      />
    );
  } else if (panelMode === "category" && selectedCategoryIdx !== null) {
    content = (
      <CategoryEditForm
        key={`cat-${selectedCategoryIdx}`}
        categoryIdx={selectedCategoryIdx}
        round={round}
      />
    );
  } else {
    content = <EmptyState />;
  }

  return <div className="re-panel">{content}</div>;
};

export default EditorPanel;
